/**
 * Created by Administrador on 03/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider){

        $stateProvider
            .state('forgot', {
                parent: 'app',
                url: '/forgot',
                data: {
                    authorities: []
                },
                views: {
                    'main@': {
                        templateUrl: 'app/layouts/forgot/forgot.html',
                        controller: 'forgotCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['home']);
                            }]
                        }
                    }
                }
            });
    }
})();
